import { Suspense, type ReactElement } from "react";
import { Outlet } from "react-router";
import { AppFooter } from "@/app/layout/app-footer";
import { PublicHeader } from "@/app/layout/public-header";
import { ClmIcon } from "@/shared/components/icons/icon-map";

/**
 * Persistent chrome for lazily loaded public pages (FR-040): the branded
 * header and shared footer render immediately at the router level, OUTSIDE
 * the lazy boundary, so a loading chunk never flashes an unbranded page or
 * shifts layout. The Suspense fallback renders inside the main landmark.
 */
export function PublicChromeLayout(): ReactElement {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <PublicHeader />
      <main className="clm-page-gutter clm-section-spacing flex-1">
        <Suspense fallback={<PublicChromeLoadingFallback />}>
          <Outlet />
        </Suspense>
      </main>
      <AppFooter />
    </div>
  );
}

function PublicChromeLoadingFallback(): ReactElement {
  return (
    <div
      className="mx-auto flex max-w-3xl items-center gap-2 rounded-lg border bg-card p-8 text-sm text-muted-foreground shadow-sm"
      role="status"
    >
      <ClmIcon name="loading" decorative className="h-6 w-6 animate-spin text-clm-brand-blue" />
      <span>Loading page</span>
    </div>
  );
}
